import { ProjetosContext } from 'contexts/projetos/ProjetosContext';
import { EtapaProjeto, indexOfEtapa, StatusEtapa } from 'models/projeto';
import ReviewEtapa from 'pages/FluxoProjetos/Components/reviewEtapa/reviewEtapa';
import { Fragment, useContext } from 'react';

export default function EtapasRevisao() {
  const {
    state: { projeto },
  } = useContext(ProjetosContext);
  return (
    <Fragment>
      {Object.values(EtapaProjeto)
        .filter((etp) => {
          const avaliacao = projeto.avaliacoes?.find(
            (av) => av.etapa === indexOfEtapa(etp)
          );
          return (
            etp !== EtapaProjeto.revisao &&
            avaliacao &&
            [
              StatusEtapa.AguardandoAprovacao,
              StatusEtapa.Aprovada,
              StatusEtapa.PontoDeAtencao,
            ].includes(avaliacao.status)
          );
        })
        .map((etp) => {
          return (
            <ReviewEtapa
              etapa={etp}
              key={etp}
              flgInfantil={projeto.flgInfantil!}
            />
          );
        })}
    </Fragment>
  );
}
